import PropTypes from "prop-types";

import { t } from "../../../services";
import { strCode } from "../../../consts";

import { WrapperContainer } from "../../../components";
import { TableStyled } from "../../../components/Table/styled";
import { LicenseHeader } from "./LicenseHeader";
import { Cell } from "../styled";

export const PackageTable = ({ heading, data }) => {
  return (
    <WrapperContainer>
      <LicenseHeader heading={heading} />
      <TableStyled>
        <tbody>
          <tr>
            <th>{t(strCode.COMPONENT)}</th>
            <th>{t(strCode.VERSION)}</th>
            <th>{t(strCode.AUTHOR)}</th>
          </tr>
          {data.map((x, id) => {
            return (
              <tr style={{ width: "100%" }} key={id}>
                <Cell style={{ width: "40%" }}>{x.name}</Cell>
                <Cell style={{ width: "20%" }}>{x.version}</Cell>
                <Cell style={{ width: "40%" }}>
                  {x.publisher} {x.email} {!x.publisher && !x.email ? x.repository : ""}
                </Cell>
              </tr>
            );
          })}
        </tbody>
      </TableStyled>
    </WrapperContainer>
  );
};

PackageTable.propTypes = {
  heading: PropTypes.string,
  data: PropTypes.array
};
